
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/user-panel",
      function () {
        return require("private-next-pages/dashboard/user-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/user-panel"])
      });
    }
  